import { BASE_URL } from '../../../../config/environmentConfig';
import * as Sentry from '@sentry/react';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { ISettlementDetailsData } from '../order-interfaces';
import { IAdjustmentBodyProps } from '../../../components/batches/AdjustmentModalContent';
import { errorAlert, successAlert, errorAlertWithoutClearing, errorAlertDirect } from '../../../components/ToastMessage';
import { GET, POST } from '../../store-helper';
import { BATCH_ACTIONS } from '../../../components/batches/BatchDetailsInformationHeader';

export interface IBatchDetailsDataSearchParams {
	pageSize?: number;
	pageNumber?: number;
}

export interface IBatchDetailsData {
	id: string,
	params: IBatchDetailsDataSearchParams,
}

export const fetchBatchDetailsData = async ({ id, params }: IBatchDetailsData): Promise<ISettlementDetailsData> => {
	try {

		return await GET({
			pathname: `${BASE_URL.ORDERS}/payouts/${id}/details`,
			params
		});

	} catch (e) {
		Sentry.setTag('fetch-payouts-details-id', id);
		sendSentryMessage({ name: `GET Fetch payouts details error`, context: e });
		console.log(e);
	}

};

export const setAdjustment = async (id: string, body: IAdjustmentBodyProps): Promise<void> => {
	await POST({ pathname: `${BASE_URL.ORDERS}/payouts/${id}/adjustment`, body });
};

export const setReserve = async (id: string, body: IAdjustmentBodyProps): Promise<void> => {
	await POST({ pathname: `${BASE_URL.ORDERS}/payouts/${id}/apply-reserve`, body });
};

export const setComment = async (id: string, comment: string): Promise<void> => {
	try {

		await POST({ pathname: `${BASE_URL.ORDERS}/payouts/${id}/comment`, body: { comment }});

		successAlert({
			title: 'Public comment was successfully saved!'
		});

	} catch (e) {
		console.log(e.response);
		errorAlert({
			title: e.response.data?.errors.Comment?.[0],
				// || e.response.data?.errors.General
				// || 'Error',
			duration: 0,
			closable: true
		});
	}
};

export const setInternalComment = async (id: string, comment: string): Promise<void> => {
	try {

		await POST({ pathname: `${BASE_URL.ORDERS}/payouts/${id}/internal-comment`, body: { comment }});

		successAlert({
			title: 'Internal comment was successfully saved!'
		});

	} catch (e) {
		console.log(e.response);
		errorAlert({
			title: e.response.data?.errors.Comment?.[0],
				// || e.response.data?.errors.General
				// || 'Error',
			duration: 0,
			closable: true
		});
	}
};

interface IPostBatch {
	batchId: string,
	action: BATCH_ACTIONS,
	onSuccess: (action: BATCH_ACTIONS) => void | Promise<void>,
	onClose: () => void,
}

export const batchAction = async ({ batchId, action, onSuccess, onClose }: IPostBatch): Promise<void> => {
	try {
		await POST({ pathname: `${BASE_URL.ORDERS}/payouts/${batchId}/${action}` });
		onSuccess(action);
	} catch (e) {
		console.log('batchesPost error', e);
		onClose();
	}
};

